import { createFileRoute } from '@tanstack/react-router';
import { CardAccountPage } from '../components/pages/CardPage/CardAccountPage';

export const Route = createFileRoute('/account/cards_/$cardId_/account')({
  component: CardAccountPage,
});
